import { getPiclickData } from '@/lib/piclick';
import { Customizer } from './components/Customizer';

export function App() {
  const data = getPiclickData();

  if (!data) {
    return (
      <div className="rounded border border-red-300 bg-red-50 p-4 text-red-900">
        <strong>window.piclickWP não encontrado.</strong> Verifique se o
        wp_localize_script está carregando antes do bundle.
      </div>
    );
  }

  return <Customizer data={data} />;
}
